import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import * as React from 'react';
import { ERROR_MESSAGES } from '../../constants/error_messages.js';
import { VisuallyHidden } from '../VisuallyHidden/VisuallyHidden.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var ariaLiveRegionReducer = function ariaLiveRegionReducer(state, action) {
  switch (action.type) {
    case "assertive":
      return _objectSpread(_objectSpread({}, state), {}, {
        assertive: action.payload
      });
    case "polite":
      return _objectSpread(_objectSpread({}, state), {}, {
        polite: action.payload
      });
    default:
      return state;
  }
};
var AriaLiveRegionDispatchContext = /*#__PURE__*/React.createContext(function () {
  return console.error(ERROR_MESSAGES.ARIA_LIVE_REGION_CONTEXT_MISSING);
});
var AriaLiveRegionProvider = function AriaLiveRegionProvider(_ref) {
  var children = _ref.children;
  var _React$useReducer = React.useReducer(ariaLiveRegionReducer, {}),
    _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
    state = _React$useReducer2[0],
    dispatch = _React$useReducer2[1];
  return /*#__PURE__*/jsxs(AriaLiveRegionDispatchContext.Provider, {
    value: dispatch,
    children: [children, /*#__PURE__*/jsxs(VisuallyHidden, {
      children: [/*#__PURE__*/jsx("div", {
        "aria-live": "assertive",
        children: state.assertive
      }), /*#__PURE__*/jsx("div", {
        "aria-live": "polite",
        children: state.polite
      })]
    })]
  });
};
AriaLiveRegionProvider.displayName = "AriaLiveRegionProvider";

export { AriaLiveRegionDispatchContext, AriaLiveRegionProvider };
